import { render, staticRenderFns } from "./CurrentPlanCard.vue?vue&type=template&id=d764aa36&"
import script from "./CurrentPlanCard.vue?vue&type=script&lang=js&"
export * from "./CurrentPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports